export const AUTH_TOKEN = 'id_token';
export const REFRESH_TOKEN = 'id_token_refresh';

// Impersonation tokens are deliberately stored in `sessionStorage` so they stay
// scoped to the single tab that started the impersonation flow. This prevents
// other tabs on the same domain (where the user is logged in under their own
// account) from picking up the impersonation session when they reload.
export const IMPERSONATION_AUTH_TOKEN = 'impersonation_id_token';
export const IMPERSONATION_REFRESH_TOKEN = 'impersonation_id_token_refresh';
export const IMPERSONATION_SESSION = 'impersonation-session';
//TODO: MOVE TO CONSTANTS PACKAGE
